import React from 'react'
import PropTypes from 'prop-types'
import Widget from './widgets/Widget'
import styled from '@emotion/styled'
import {useDispatch} from 'react-redux'
import * as Actions from 'state/actions'

const ResendWrapper = styled.div`
  align-self: flex-end;
  margin-top: 10px;
  margin-bottom: 8px;
`
const ResendLink = styled.span`
  color: #c86694;
  text-transform: uppercase;
  margin-left: 10px;
  font-weight: 900;
  cursor: pointer;
`



const RunningActivity = ({payload, isLeft, endOfBlock, avatar}) => {
  const dispatch = useDispatch()
  const resend = payload.tempId && !payload.failed ? null : (
    <ResendWrapper>
      Failed to send:
      <ResendLink
        onClick={() => dispatch(Actions.resendMessage(payload))}
      >
        resend message
      </ResendLink>
    </ResendWrapper>
  )

  return (
    <>
      <Widget
        isDim={payload.tempId && !payload.failed}
        payload={payload}
        avatar={avatar}
        endOfBlock={endOfBlock}
        isLeft={isLeft}
      />
      {resend}
    </>
  )
}

RunningActivity.propTypes = {
  payload: PropTypes.any,
  isLeft: PropTypes.bool.isRequired,
  avatar: PropTypes.any,
  endOfBlock: PropTypes.bool
}

export default RunningActivity
